import React from 'react';
import { getEnvironment } from '../../utils/environment';

const EnvironmentIndicator = () => {
  const env = getEnvironment();
  
  // Don't show indicator in production to keep it clean
  if (env.name === 'PRODUCTION') {
    return null;
  }

  return (
    <div className={`fixed top-0 right-0 z-[60] ${env.color} text-white text-xs font-bold px-3 py-1 rounded-bl-md shadow-lg`}>
      {env.name}
    </div>
  );
};

export default EnvironmentIndicator;